const InstructorData = ({
  title,
  data,
  className = "tw-container tw-mx-auto tw-p-5 tw-bg-white tw-rounded-[10px] tw-shadow-md tw-relative",
}) => {
  return (
    <section className={className}>
      {data?.instructorImage !== undefined && (
        <div className="tw-absolute tw-size-16 lg:tw-size-20 tw-top-4 tw-rounded-full tw-right-10 tw-bg-white tw-shadow-lg tw-border-2 tw-p-2 tw-border-primary/5">
          <img
            src={data?.instructorImage || "/imgs/partner.png"}
            alt="Profile"
            className="tw-size-full tw-rounded-full tw-object-cover"
          />
        </div>
      )}
      <h3 className="tw-text-xl tw-font-semibold tw-text-red-600 tw-mb-4 tw-border-b tw-pb-2">
        {title}
      </h3>
      <div className={`tw-grid  tw-grid-cols-1 tw-gap-2 tw-text-gray-700`}>
        <div>
          <h2 className="tw-text-primary tw-text-lg tw-font-bold !tw-my-1">
            {data?.instructorName}
          </h2>
          <h4>{data?.instructorTitle}</h4>
        </div>
        <p className="tw-my-3">{data?.instructorBio}</p>
      </div>
    </section>
  );
};

export default InstructorData;
